import { useEffect } from "react";
import { useBotsStore } from "../stores/bots.store";
import { onValue, off, ref } from "firebase/database";
import { db } from "../lib/firebase";

export function useSubscribeToBotData(botId: string) {
  const addOrUpdateBot = useBotsStore(state => state.addOrUpdateBot);

  useEffect(() => {
    const botDataRef = ref(db, `botData/${botId}`);
    const unsubscribe = onValue(botDataRef, snapshot => {
      const data = snapshot.val();
      if (data) {
        addOrUpdateBot(botId, { data });
      }
    });

    return () => off(botDataRef, "value", unsubscribe);
  }, [botId, addOrUpdateBot]);
}
